import { type ZodType, z } from 'zod';

export type GetFromLocalStorageInputWithSchema<T> = {
  scope?: string;
  key: string;
  schema?: ZodType<T>;
};

export enum ScanMode {
  RECEIPT = 'SURFACE',
  TUNNEL = 'TUNNEL',
}

export const scanSiteSchema = z.object({
  id: z.uuid({ message: 'Wrong site Id' }),
  label: z.string().optional(),
  scanMode: z.enum(ScanMode),
  isQuarantineEnabled: z.boolean().default(true),
  isOnHoldOptionEnabled: z.boolean().default(false),
});

export const segmentTypesSchema = z.array(z.string());

export const scanPatternSchema = z.object({
  startIndex: z.number(),
  extractLength: z.number(),
});

export type ScanSiteSchema = z.infer<typeof scanSiteSchema>;
export type SegmentTypesSchema = z.infer<typeof segmentTypesSchema>;
export type ScanPatternSchema = z.infer<typeof scanPatternSchema>;
